export const config = {
  clientKey: 'vez-sedezi',
}
